module.exports = __webpack_public_path__ + "files/OBSERVA4.52e323634a9631b92da6955b1f602edf.zip";